import React from 'react'
import { Section, HighlightedElement } from './utils'

export default function EvernoteGuide({ className, style }) {
  return (
    <section className={className} style={style}>
      <p>
        You can export your content from Evernote into Slite one doc at a time
        or all at once, here's how:
      </p>
      <br />

      <Section>What you need to know</Section>
      <ul style={{ listStyle: 'inherit', paddingLeft: 15 }}>
        <li>
          For Evernote content import into Slite, the Desktop app is required,
          imports won't work in the Slite web app.
        </li>
        <li>
          Sadly, your images will not be saved. You can drag and drop them back
          in separately from the{' '}
          <HighlightedElement>note_title.resources</HighlightedElement> folder.
          We apologize for this inconvenience!
        </li>
      </ul>
      <br />

      <Section>Exporting individual Evernote docs into Slite</Section>
      <ol style={{ paddingLeft: 15 }}>
        <li>
          In Evernote, select the docs you wish to export, right click on them
          and select "Export Notes..."
        </li>
        <li>
          Export as <span className="font-weight-medium">html</span>
        </li>
        <li>
          In Slite, import the html files via the{' '}
          <HighlightedElement>Import</HighlightedElement> content menu{' '}
          <span role="img" aria-label="boom">
            💥
          </span>
        </li>
      </ol>
      <br />
      <h3 className="font-size-large margin-bottom-small shade-10">
        Exporting Evernote docs in bulk into Slite
      </h3>
      <ol style={{ paddingLeft: 15 }}>
        <li>Click on 'Notebooks' to enter the notebook view</li>
        <li>Select File > Export all Notes...</li>
        <li>
          Export as <HighlightedElement>html</HighlightedElement>
        </li>
        <li>
          In Slite, import the html files via the{' '}
          <HighlightedElement>Import</HighlightedElement> content menu
          <span role="img" aria-label="boom">
            💥
          </span>
        </li>
      </ol>
    </section>
  )
}
